
import {windVane} from "../../../utils/tmallGenius";
import {fetchChannelList, queryChannelNumberPublic} from "../../../api";
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {Group, Cell},
data() {
return {
channelList: [],
publicChannelList: []
};
},
/*------------------------------------------- 开始运行 -------------------------------------------------------*/
created() {
const params = {
token: sessionStorage.getItem("token"),
deviceId: this.$route.query.deviceId
};
fetchChannelList(params).then(res => {
const {data, status, message} = res;
if (status == 0) {
this.channelList = data;
} else {
this.toast_fail();
}
});
queryChannelNumberPublic(params).then(res => {
const {data, status, message} = res;
if (status == 0) {
this.publicChannelList = data;
} else {
this.toast_fail();
}
});
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("频道信息");
next();
},
methods: {
/*------------------------------------------- 自定义方法-------------------------------------------*/
gotoEditChannel(item) {
this.$router.push({
path: `/settings/channel/add`,
query: {
deviceId: this.$route.query.deviceId,
customChannelId: item.customChannelId,
channelName: item.channelName,
channelCode: item.channel
}
});
},
gotoAddChannle() {
this.$router.push({
path: `/settings/channel/add`,
query: {
deviceId: this.$route.query.deviceId
}
});
}
/*------------------------------------------- 绑定方法 -------------------------------------------------------*/
}
};



// WEBPACK FOOTER //
// ./src/pages/settings/channel/ChannelList.vue